import { render, staticRenderFns } from "./StatisticOrderSummariesTable.vue?vue&type=template&id=8729434a&scoped=true&"
import script from "./StatisticOrderSummariesTable.vue?vue&type=script&setup=true&lang=ts&"
export * from "./StatisticOrderSummariesTable.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./StatisticOrderSummariesTable.vue?vue&type=style&index=0&id=8729434a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8729434a",
  null
  
)

export default component.exports